// extracted by mini-css-extract-plugin
export default {"container":"LegalDisclaimer-module__container__hIsFALk"};